var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.00082C7.47 2.00037 2.99963 6.47 2.99918 12C2.99873 17.53 7.46836 22.0004 12.9984 22.0008C18.5284 22.0013 22.9987 17.5316 22.9992 12.0016C22.9996 6.47164 18.53 2.00127 13 2.00082ZM12.9985 20.0008C8.58852 20.0005 4.99882 16.4102 4.99918 12.0002C4.99954 7.59016 8.58984 4.00046 12.9998 4.00082C17.4098 4.00118 20.9995 7.59148 20.9992 12.0015C20.9988 16.4115 17.4085 20.0012 12.9985 20.0008ZM12.9993 10.5908L16.5896 7.00111L17.9995 8.41123L14.4092 12.0009L17.9989 15.5912L16.5888 17.0011L12.9991 13.4108L9.40877 17.0005L7.99889 15.5904L11.5892 12.0007L7.99947 8.41041L9.40959 7.00053L12.9993 10.5908Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel24Px);
export default __webpack_public_path__ + "static/media/cancel_24px.a3a32e71889e4ad7be7092d4639336d9.svg";
export { ForwardRef as ReactComponent };